(function () {
  var AUTOPLAY_MS = 3000;

  function initSnapScroller(track) {
    if (!track || track.dataset.btsSnapInit === "1") return;

    var cards = track.querySelectorAll(":scope > div");
    if (!cards || cards.length < 2) return;

    track.dataset.btsSnapInit = "1";

    // Clone first card to the end for seamless loop
    var firstClone = cards[0].cloneNode(true);
    firstClone.dataset.btsClone = "1";
    track.appendChild(firstClone);

    var timer = null;
    var paused = false;

    function getGapPx() {
      try {
        var styles = window.getComputedStyle(track);
        var gap = styles.columnGap || styles.gap || "16px";
        return parseFloat(gap) || 16;
      } catch (e) {
        return 16;
      }
    }

    function getStep() {
      var first = track.querySelector(":scope > div");
      if (!first) return 0;
      return first.getBoundingClientRect().width + getGapPx();
    }

    function setImmediateScroll(x) {
      track.style.scrollBehavior = "auto";
      track.scrollLeft = x;
      requestAnimationFrame(function () {
        track.style.scrollBehavior = "smooth";
      });
    }

    function goNext() {
      var step = getStep();
      if (!step) return;

      var maxScroll = track.scrollWidth - track.clientWidth;
      var target = track.scrollLeft + step;

      // If we are about to move into the clone zone, animate to end then jump back to start
      if (target >= maxScroll - step * 0.5) {
        track.scrollTo({ left: maxScroll, behavior: "smooth" });

        // Jump back to start right after the smooth scroll finishes
        setTimeout(function () {
          setImmediateScroll(0);
        }, 380);
      } else {
        track.scrollTo({ left: target, behavior: "smooth" });
      }
    }

    function start() {
      if (timer || paused) return;
      timer = setInterval(goNext, AUTOPLAY_MS);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function pause() { paused = true; stop(); }
    function resume() { paused = false; start(); }

    // Pause on hover/touch
    track.addEventListener("mouseenter", pause);
    track.addEventListener("mouseleave", resume);
    track.addEventListener("touchstart", pause, { passive: true });
    track.addEventListener("touchend", function () { setTimeout(resume, 500); }, { passive: true });

    // Pause when tab hidden
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) pause();
      else resume();
    });

    // Start
    start();

    // If user manually scrolls, keep autoplay but avoid fighting momentum
    track.addEventListener("scroll", function () {
      // no-op; just here if you want to extend later
    });
  }

  function initAll() {
    document.querySelectorAll(".bts-snap").forEach(initSnapScroller);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  setTimeout(initAll, 500);
  setTimeout(initAll, 1500);
})();
